module.exports = __webpack_public_path__ + "img/Candy Flavored.d1519e08.jpg";